import type React from 'react';
import { forwardRef } from 'react';

export type CheckboxProps = {
  label: React.ReactNode;
  error?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, ...props }, ref) => {
    return (
      <div className="flex items-center gap-3">
        <div className="relative flex h-5 w-5 items-center justify-center">
          <input
            ref={ref}
            type="checkbox"
            className="peer h-5 w-5 appearance-none rounded-xs border border-white/40 bg-transparent transition-colors hover:border-white/60 focus:ring-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50"
            {...props}
          />
          <svg
            className="pointer-events-none absolute hidden h-4 w-4 stroke-white stroke-2 peer-checked:block"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <label
          htmlFor={props.id || props.name}
          className="text-sm font-medium text-white/80 select-none"
        >
          {label}
        </label>
        {error && <span className="text-xs text-red-500">{error}</span>}
      </div>
    );
  },
);

Checkbox.displayName = 'Checkbox';
